import { ServiceKey, ServiceScope } from "@journeyteam/dependency-injection";
import * as React from "react";

export interface IServiceContext {
	scope: ServiceScope;
}
export const rootScope = ServiceScope.startNewRoot();
rootScope.finish();
export const ServiceContext = React.createContext<IServiceContext>({
	scope: rootScope,
});

export function useService<T>(key: ServiceKey<T>) {
	const ctx = React.useContext(ServiceContext);
	return ctx.scope.consume(key);
}
